<template>
    <div class="upload-cell">
        <div class="title">{{ index }}.{{ title }}</div>
        <div class="content">
            <van-uploader
                v-model="fileList"
                multiple
                preview-size="80px"
                :max-count="6"
                :preview-options="previewOptions"
            />
        </div>
    </div>
</template>

<script>
import { Uploader } from "vant";

export default {
    name: "upload",
    components: {
        "van-uploader": Uploader
    },
    props: {
        index: {
            Number,
            default: 1
        },
        title: {
            String,
            default: "这里是问题题目:"
        }
    },
    data() {
        return {
            fileList: [],
            previewOptions: { closeable: true, closeOnPopstate: true }
        };
    },
    methods: {},
    watch: {
        fileList(val) {
            this.$emit("input", val);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.upload-cell {
    .content {
        width: 350px;
        margin: 20px 0 0 16px;
    }
}
</style>
